<graphql-data-table [query]="computedQuery | async" [columns]="['startTime', 'source', 'target', 'duration']">


  <!--<ng-container matColumnDef="extra">
    <th mat-header-cell *matHeaderCellDef>Cradle to grave</th>
    <td mat-cell *matCellDef="let row"><a routerLink="/CradleToGravePage?initialCallId={{row.initialCallId}}">radle to grave</a></td>
  </ng-container>-->


  <ng-container matColumnDef="startTime">
    <th mat-header-cell *matHeaderCellDef>

      <div style="display: inline-block;">
        Start Time
      </div>

      <div style="display: inline-block;">
        <button mat-icon-button [matMenuTriggerFor]="startTimeFilterPopover" class="graphql-data-table-header-button">
          <span class="material-icons">filter_list</span>
        </button>
        <button mat-icon-button [style.visibility]="(minDateTimeDateFilter | async) != null || (minDateTimeTimeFilter | async) != '' || (maxDateTimeDateFilter | async) != null || (maxDateTimeTimeFilter | async) != '' ? '' : 'hidden'" (click)="onClearStartTimeFilter()" class="graphql-data-table-header-button">
          <span class="material-icons">close</span>
        </button>


        <mat-menu #startTimeFilterPopover [xPosition]="0" [yPosition]="0" class="ngx-mat-popover graphql-data-table-header-popover" [hasBackdrop]="true">
          <ng-template matMenuContent>
            <div mat-menu-item
                 [disableRipple]="true"
                 (keydown.tab)="$event.stopPropagation()"
                 (click)="$event.stopPropagation()"
                 class="">
              <div style="display: inline-block; text-align: center;">
                <div>
                  <input matInput [matDatepicker]="minDateTimeDatePicker" placeholder="dd/mm/yyyy" [ngModel]="minDateTimeDateFilter | async" (ngModelChange)="minDateTimeDateFilter.next($event)"  style="margin-right: -13px;" readonly (click)="minDateTimeDatePicker.open()"/>
                  <mat-datepicker #minDateTimeDatePicker></mat-datepicker>
                </div>
                <div>
                  <input matInput [ngxTimepicker]="minDateTimeTimePicker" [format]="24" placeholder="--:--" [ngModel]="minDateTimeTimeFilter | async" (ngModelChange)="minDateTimeTimeFilter.next($event)" readonly/>
                  <ngx-material-timepicker #minDateTimeTimePicker></ngx-material-timepicker>
                </div>
              </div>

              <div style="display: inline-block; text-align: center; padding: 0 5px; vertical-align: top; padding-top: 8px;">
                -
              </div>

              <div style="display: inline-block; text-align: center;">
                <div>
                  <input matInput [matDatepicker]="maxDateTimeDatePicker" placeholder="dd/mm/yyyy" [ngModel]="maxDateTimeDateFilter | async" (ngModelChange)="maxDateTimeDateFilter.next($event)" style="margin-right: -13px;" readonly (click)="maxDateTimeDatePicker.open()" />
                  <mat-datepicker #maxDateTimeDatePicker></mat-datepicker>
                </div>
                <div>
                  <input matInput [ngxTimepicker]="maxDateTimeTimePicker" [format]="24" placeholder="--:--" [ngModel]="maxDateTimeTimeFilter | async" (ngModelChange)="maxDateTimeTimeFilter.next($event)" style="width:50px" readonly />
                  <ngx-material-timepicker #maxDateTimeTimePicker></ngx-material-timepicker>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-menu>


      </div>      
    </th>
    <td mat-cell *matCellDef="let row">{{ row.startTime | date: 'dd/MM/yyyy HH:mm:ss' }} <span style="display:none">{{row.callId}}</span></td>
  </ng-container>

  <ng-container matColumnDef="source">
    <th mat-header-cell *matHeaderCellDef>
      <div style="display: inline-block;">
        Source
      </div>

      <div style="display: inline-block;">
        <button mat-icon-button [matMenuTriggerFor]="sourceFilterPopover" class="graphql-data-table-header-button">
          <span class="material-icons">filter_list</span>
        </button>
        <button mat-icon-button [style.visibility]="(sourceFilter | async) != '' ? '' : 'hidden'" (click)="sourceFilter.next('')"  class="graphql-data-table-header-button">
          <span class="material-icons" >close</span>
        </button>


        <mat-menu #sourceFilterPopover [xPosition]="0" [yPosition]="0" class="ngx-mat-popover graphql-data-table-header-popover" [hasBackdrop]="true">
          <ng-template matMenuContent>
            <span mat-menu-item
                  [disableRipple]="true"
                  (keydown.tab)="$event.stopPropagation()"
                  (click)="$event.stopPropagation()"
                  class="">
              <input matInput placeholder="Search" [value]="sourceFilter | async" (keyup)="sourceFilter.next($event.target.value)">
            </span>
          </ng-template>
        </mat-menu>
      </div>
    </th>
    <td mat-cell *matCellDef="let row">
      <ng-container *ngIf="row.sourceOwnerId != null; else sourcePhoneNumber">
        {{row.sourceOwnerTypeId | ownerTypeIdToString}}:
        {{row.sourceOwner}}
      </ng-container>

      <ng-template #sourcePhoneNumber>
        {{row.sourcePhoneNumber }}
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="target">
    <th mat-header-cell *matHeaderCellDef>
      <div style="display: inline-block;">
        Target
      </div>

      <div style="display: inline-block;">
        <button mat-icon-button [matMenuTriggerFor]="targetFilterPopover" class="graphql-data-table-header-button">
          <span class="material-icons" >filter_list</span>
        </button>
        <button mat-icon-button [style.visibility]="(targetFilter | async) != '' ? '' : 'hidden'" (click)="targetFilter.next('')" class="graphql-data-table-header-button">
          <span class="material-icons">close</span>
        </button>


        <mat-menu #targetFilterPopover [xPosition]="0" [yPosition]="0" class="ngx-mat-popover graphql-data-table-header-popover" [hasBackdrop]="true">
          <ng-template matMenuContent>
            <span mat-menu-item
                  [disableRipple]="true"
                  (keydown.tab)="$event.stopPropagation()"
                  (click)="$event.stopPropagation()"
                  class="">
              <input matInput placeholder="Search" [value]="targetFilter | async" (keyup)="targetFilter.next($event.target.value)">
            </span>
          </ng-template>
        </mat-menu>
      </div>
    </th>
    <td mat-cell *matCellDef="let row">



      <ng-container *ngIf="row.targetOwnerId != null; else targetPhoneNumber">
        {{row.targetOwnerTypeId | ownerTypeIdToString}}:
        {{row.targetOwner}}
      </ng-container>

      <ng-template #targetPhoneNumber>
        {{row.targetPhoneNumber }}
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="duration">
    <th mat-header-cell *matHeaderCellDef>
      <div style="display: inline-block;">
        Duration
      </div>

      <div style="display: inline-block;">
        <button mat-icon-button [matMenuTriggerFor]="durationFilterPopover" class="graphql-data-table-header-button">
          <span class="material-icons">filter_list</span>
        </button>
        <button mat-icon-button [style.visibility]="(minDurationFilter | async) != '' || (maxDurationFilter | async) != '' ? '' :'hidden'" (click)="minDurationFilter.next('');maxDurationFilter.next('');" class="graphql-data-table-header-button">
          <span class="material-icons" >close</span>
        </button>

        <mat-menu #durationFilterPopover [xPosition]="0" [yPosition]="0" class="ngx-mat-popover graphql-data-table-header-popover" [hasBackdrop]="true">
          <ng-template matMenuContent>
            <div mat-menu-item
                 [disableRipple]="true"
                 (keydown.tab)="$event.stopPropagation()"
                 (click)="$event.stopPropagation()"
                 class="">
              <div style="display: inline-block; text-align: center;">
                <input matInput [ngxTimepicker]="minDurationPicker" [format]="24" placeholder="--:--" [ngModel]="minDurationFilter | async" (ngModelChange)="minDurationFilter.next($event)" style="width:50px" readonly/>
                <ngx-material-timepicker #minDurationPicker></ngx-material-timepicker>
              </div>

              <div style="display: inline-block; text-align: center; padding: 0 5px;">
                -
              </div>

              <div style="display: inline-block; text-align:center;">
                <input matInput [ngxTimepicker]="maxDurationPicker" [format]="24" placeholder="--:--" [ngModel]="maxDurationFilter | async" (ngModelChange)="maxDurationFilter.next($event)" style="width:50px" readonly/>
                <ngx-material-timepicker #maxDurationPicker></ngx-material-timepicker>
              </div>
            </div>
          </ng-template>
        </mat-menu>
      </div>

    </th>
    <td mat-cell *matCellDef="let row">{{row.duration / 1000 | secondsToTimeSpan}}</td>
  </ng-container>


  <ng-template #expandedDetail let-row="row" let-expanded="expanded">
    <ng-container *ngIf="expanded == true">
      <cradle-to-grave [initialCallId]="row.initialCallId" style="min-width:100%; padding:24px 0"></cradle-to-grave>
    </ng-container>
  </ng-template>

</graphql-data-table>
